import { Component, OnInit, inject, signal } from '@angular/core';
import { FileHandle } from '../../../../../drag-drop-files.directive';
import { LossPreventionService } from '../../../../../service/loss-prevention.service';

@Component({
  selector: 'app-loss-prevention-admin-review-priorities',
  templateUrl: './review-priorities.component.html',
  styleUrl: './review-priorities.component.scss',
  standalone: false,
})
export class LossPreventionAdminReviewPrioritiesComponent implements OnInit {
  private lossPreventionService = inject(LossPreventionService);

  csvFiles: FileHandle[] = [];
  public isUpdating: boolean;
  public locationPriorityCount = signal<number>(0);

  ngOnInit(): void {
    this.isUpdating = true;
    this.lossPreventionService.getCountOfPrioritizedLocations().subscribe((result) => {
      this.isUpdating = false;
      this.locationPriorityCount.set(result);
    });
  }

  filesDropped($event: FileHandle[]) {
    this.csvFiles = $event;
    this.uploadAndProcessCsv();
  }

  onCsvPicked($event: Event) {
    this.csvFiles = [];
    const files = ($event.target as HTMLInputElement).files;
    for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
      this.csvFiles.push({ file: files[fileIndex], url: files[fileIndex].webkitRelativePath });
    }
    this.uploadAndProcessCsv();
  }

  uploadAndProcessCsv() {
    if (this.csvFiles.length === 0) {
      return;
    }
    this.isUpdating = true;
    this.lossPreventionService.uploadReviewPrioritiesCsv(this.csvFiles[0].file).subscribe((result) => {
      this.isUpdating = false;
      this.locationPriorityCount.set(result);
    });
  }
}
